import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Table,
  Loader,
  Header,
  Icon,
  Menu,
} from 'semantic-ui-react';

import AuditLogTableRow from './../audit-log-table-row';

const headerCells = [
  'Time', 'User', 'Action', 'Campaign', 'Link',
];

const loadingTableRowStyle = {
  height: 549,
};

const downloadCsvLinkStyle = {
  color: '#c71f7e',
  border: '1px solid #c71f7e',
  padding: '5px 15px',
  borderRadius: 6,
};

const tableStyle = {
  width: '100%',
};

const textCenteredStyle = {
  textAlign: 'center',
};

const paginationStyle = {
  marginBottom: 20,
};

const TablePagination = ({
  onPageDecrement,
  onPageIncrement,
  currentOffset,
  shouldDisableNextButton,
}) => (
  <Menu compact floated="right" style={paginationStyle}>
    <Menu.Item as="a" onClick={onPageDecrement} disabled={currentOffset === 0}>
      <Icon name="angle left" />
    </Menu.Item>
    <Menu.Item as="a" disabled={shouldDisableNextButton} onClick={onPageIncrement}>
      <Icon name="angle right" />
    </Menu.Item>
  </Menu>
);

TablePagination.propTypes = {
  onPageDecrement: PropTypes.func.isRequired,
  onPageIncrement: PropTypes.func.isRequired,
  currentOffset: PropTypes.number.isRequired,
  shouldDisableNextButton: PropTypes.bool.isRequired,
};

const TableBodyLoader = () => (
  <Table.Body>
    <Table.Row style={loadingTableRowStyle}>
      <Table.Cell colSpan={5}>
        <Loader
          active
          content="Loading feed..."
          inline="centered"
        />
      </Table.Cell>
    </Table.Row>
  </Table.Body>
);

const TableEmptyState = () => (
  <Table.Body>
    <Table.Row style={loadingTableRowStyle}>
      <Table.Cell colSpan={5} style={textCenteredStyle}>
        <Header icon size="large">
          <Icon name="wait outline" color="orange" />
            No events yet
          <Header.Subheader>
            Please try again later
          </Header.Subheader>
        </Header>
      </Table.Cell>
    </Table.Row>
  </Table.Body>
);

const AuditLogTable = ({
  shouldRenderLoader,
  isLoaded,
  events,
  currentOffset,
  shouldDisableNextButton,
  onPageIncrement,
  onPageDecrement,
}) => {
  const shouldRenderEmptyState = !shouldRenderLoader && _.isEmpty(events);
  const shouldRenderTable = isLoaded && !shouldRenderLoader && !shouldRenderEmptyState;

  const paginationProps = {
    onPageDecrement,
    onPageIncrement,
    currentOffset,
    shouldDisableNextButton,
  };

  return (
    <div>
      <Table celled style={tableStyle}>
        {
          shouldRenderTable &&
          <Table.Header>
            <Table.Row>
              {
                _.map(headerCells, cell => (
                  <Table.HeaderCell>{ cell }</Table.HeaderCell>
                ))
              }
            </Table.Row>
          </Table.Header>
        }
        {
          shouldRenderTable &&
          <Table.Body>
            { _.map(events, event => (<AuditLogTableRow {...event} />)) }
          </Table.Body>
        }
        {
          shouldRenderLoader && <TableBodyLoader />
        }
        {
          shouldRenderEmptyState && <TableEmptyState />
        }
      </Table>
      {
        shouldRenderTable &&
        <TablePagination {...paginationProps} />
      }
    </div>
  );
};

AuditLogTable.propTypes = {
  isLoaded: PropTypes.bool.isRequired,
  shouldRenderLoader: PropTypes.bool.isRequired,
  shouldDisableNextButton: PropTypes.bool.isRequired,
  events: PropTypes.array.isRequired,
  onPageDecrement: PropTypes.func.isRequired,
  onPageIncrement: PropTypes.func.isRequired,
  currentOffset: PropTypes.number.isRequired,
  hasExportFeature: PropTypes.bool,
  organisationName: PropTypes.string.isRequired,
};

AuditLogTable.defaultProps = {
  hasExportFeature: true,
};


export default AuditLogTable;



/** WEBPACK FOOTER **
 ** ./src/components/audit-log-table/index.js
 **/